"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ToastProvider", {
    enumerable: true,
    get: function() {
        return ToastProvider;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_wildcard(require("react"));
const _Theme = require("../../contexts/Theme");
const _IframePageInfoContext = require("../../contexts/IframePageInfoContext");
const _reacttransitiongroup = require("react-transition-group");
const _BodyPortal = require("../BodyPortal/BodyPortal");
const _ToastContext = require("./ToastContext");
const _useFloatingInIframe = require("../../hooks/useFloatingInIframe");
const _AlertToast = require("./AlertToast");
const _Toastconstants = require("./Toast.constants");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
let lastId = 0;
const ToastProvider = (param)=>{
    let { children } = param;
    const { zIndexes } = (0, _Theme.useTheme)();
    const [toasts, setToasts] = (0, _react.useState)([]);
    const { inIframe } = (0, _react.useContext)(_IframePageInfoContext.IframeResizerContext);
    const { floating, top, left, position } = (0, _useFloatingInIframe.useFloatingInIframe)({
        placement: "bottom",
        fixedSize: true
    });
    const exitDirectionRef = (0, _react.useRef)("bottom");
    const internalRefs = (0, _react.useRef)({});
    (0, _react.useEffect)(()=>{
        internalRefs.current = {
            ...internalRefs.current
        };
    }, [
        toasts
    ]);
    const refs = (0, _react.useMemo)(()=>toasts.reduce((prev, nextToast)=>({
                ...prev,
                [nextToast.id]: (el)=>{
                    internalRefs.current[nextToast.id] = el;
                }
            }), {}), [
        toasts
    ]);
    (0, _react.useEffect)(()=>{
        floating.update();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        toasts
    ]);
    const removeToast = (0, _react.useCallback)((id)=>{
        exitDirectionRef.current = "bottom";
        setToasts(toasts.filter((toast)=>toast.id !== id));
    }, [
        toasts
    ]);
    const showToast = (0, _react.useCallback)((type, message, options)=>{
        const id = lastId++;
        const remove = ()=>{
            var _internalRefs_current_id;
            (_internalRefs_current_id = internalRefs.current[id]) === null || _internalRefs_current_id === void 0 ? void 0 : _internalRefs_current_id.remove();
        };
        // If a notification exists of the same name, remove it from the existing
        // toasts array.
        const filteredToasts = toasts.filter((toast)=>toast.name == null || (options === null || options === void 0 ? void 0 : options.name) == null || toast.name !== options.name);
        const newToast = {
            id,
            message,
            type,
            opacity: 1,
            remove,
            ...options
        };
        exitDirectionRef.current = filteredToasts.length === _Toastconstants.TOASTS_LIMIT ? "top" : "bottom";
        setToasts([
            newToast,
            ...filteredToasts.slice(0, _Toastconstants.TOASTS_LIMIT - 1)
        ]);
        if (newToast.type !== "negative" && newToast.autoDismiss !== false) {
            setTimeout(()=>{
                newToast.remove();
            }, _Toastconstants.TOAST_TIMEOUT);
        }
        return {
            remove
        };
    }, [
        toasts,
        internalRefs
    ]);
    const value = (0, _react.useRef)({
        provided: true,
        neutral: showToast.bind(null, "neutral"),
        negative: showToast.bind(null, "negative"),
        positive: showToast.bind(null, "positive")
    });
    (0, _react.useEffect)(()=>{
        value.current.neutral = showToast.bind(null, "neutral");
        value.current.negative = showToast.bind(null, "negative");
        value.current.positive = showToast.bind(null, "positive");
    }, [
        showToast
    ]);
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement(_ToastContext.ToastContext.Provider, {
        value: value.current
    }, children), /*#__PURE__*/ _react.default.createElement(_BodyPortal.BodyPortal, null, /*#__PURE__*/ _react.default.createElement("div", {
        ref: floating.floating,
        className: _style.default.dynamic([
            [
                "d5779cc97519a6b0",
                [
                    position !== null && position !== void 0 ? position : "fixed",
                    inIframe ? "auto" : "0",
                    inIframe ? top : "auto",
                    left,
                    zIndexes.toast
                ]
            ]
        ])
    }, /*#__PURE__*/ _react.default.createElement(_reacttransitiongroup.TransitionGroup, null, toasts.map((toast, index)=>/*#__PURE__*/ _react.default.createElement(_reacttransitiongroup.Transition, {
            key: toast.id,
            timeout: {
                enter: 0,
                exit: _Toastconstants.TOAST_ANIMATION_DURATION_MS
            },
            onExited: ()=>{
                // Update the position of the the floating toast container element since its size will have changed.
                setTimeout(()=>{
                    floating.update();
                });
            }
        }, (status)=>/*#__PURE__*/ _react.default.createElement(_AlertToast.AlertToast, {
                key: toast.id,
                index: index,
                message: toast.message,
                variant: toast.type,
                icon: toast.icon,
                size: toast.size,
                primaryAction: toast.primaryAction,
                secondaryAction: toast.secondaryAction,
                remove: ()=>{
                    removeToast(toast.id);
                },
                onClose: toast.showClose !== false ? ()=>removeToast(toast.id) : undefined,
                ref: refs[toast.id],
                status: status,
                exitDirection: index > 0 ? exitDirectionRef.current : "bottom"
            })))))), /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "d5779cc97519a6b0",
        dynamic: [
            position !== null && position !== void 0 ? position : "fixed",
            inIframe ? "auto" : "0",
            inIframe ? top : "auto",
            left,
            zIndexes.toast
        ]
    }, "div.__jsx-style-dynamic-selector{position:".concat(position !== null && position !== void 0 ? position : "fixed", ";pointer-events:none;width:100%;bottom:").concat(inIframe ? "auto" : "0", ";top:").concat(inIframe ? top : "auto", ";left:").concat(left, ";display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;z-index:").concat(zIndexes.toast, "}")));
};

//# sourceMappingURL=ToastProvider.js.map